import { useState } from "react";
import "../../assets/css/login/index.css";

import { Input } from "reactstrap";
import Buttons from "../../Components/Buttons";
import {
  requestAuth,

} from "../../actions/login";
import { validateForm } from "../../utils";
import Spinner from "../../Components/Spinner";


import { useSelector, useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { useNavigate } from "react-router-dom";

const styles: React.CSSProperties = {
  backgroundImage: `url(${process.env.PUBLIC_URL}/commons/bg_login.png)`,
};

interface FrmLogin {
  user?: string;
  password?: string;
}

const Login: React.FC = ({ history }: any) => {
  // const [selectAmb, setSelectAmb] = useState<boolean>(false);
  const [frmValues, setFrmValues] = useState<FrmLogin>({});
  const [errors, setErrors] = useState<FrmLogin>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { idUsuario, ambientes, jwt, token, fullName } = useSelector(
    (state: any) => state.user
  );
  const { btnSimple } = useSelector((state: any) => state.theme);

  const dispatch: Dispatch = useDispatch();
  const navigate = useNavigate();



  const handleLogin = async () => {
    let isValid = validateForm({
      schema: {
        user: { message: "Ingrese el usuario" },
        password: { message: "Ingrese el password" },
      },
      values: frmValues,
    });
    if (Object.keys(isValid).length) {
      setErrors({ ...isValid });
      return false;
    }
    setIsLoading(true);
    const isSuccess: any = await dispatch(
      requestAuth(frmValues.user || "", frmValues.password || "") as any
    );


    if (isSuccess) {
      setTimeout(() => {
        navigate("/inicio");
        setIsLoading(false);
      }, 5000);
    }
  };


  return (
    <div className={"main"} style={styles}>
      <div className={"container-frm"}>
        <Buttons
          title={"Inicio de Sesión"}
          type={"simple"}
          config={btnSimple}
          height={127}
        />
        <div className={"container-inputs"}>
          <div style={{ paddingTop: 30 }} />
          <div>
            <label className={"lbl-general"}>Usuario</label>
            <Input
              type={"text"}
              className={`input ${errors["user"] ? "input_error" : ""}`}
              placeholder={errors["user"] ? errors["user"] : ""}
              onChange={(e) =>
                setFrmValues({
                  user: e.target.value,
                  password: frmValues.password,
                })
              }
              tabIndex={1}
              id="user"
            />
          </div>
          <div>
            <label className={"lbl-general"}>Contraseña</label>
            <Input
              type={"password"}
              className={`input ${errors["password"] ? "input_error" : ""}`}
              placeholder={errors["password"] ? errors["password"] : ""}
              onChange={(e) =>
                setFrmValues({
                  user: frmValues.user,
                  password: e.target.value,
                })
              }
              tabIndex={2}
              onKeyDown={(e: any) => {
                if (e.key === "Enter") {
                  handleLogin();
                }
              }}
              id="password"

            />
          </div>
          <div>
            {isLoading ? (
              <Spinner />
            ) : (
              <Buttons
                title={"Entrar"}
                type={"login"}
                handleClick={handleLogin}
                height={56}
                onKeyDown={(e: any) => {
                  if (e.key === "Enter") {
                    handleLogin();
                  }
                }}
                tabIndex={3}
              />
            )}
          </div>
          <div style={{ paddingTop: 30 }} />
        </div>
      </div>
    </div>
  );
};

export default Login;
